module.exports = __webpack_public_path__ + "img/big_1_57.5203397b.png";